// components
import Page from 'components/page';
import Registration from 'components/registration';
import type { GetServerSidePropsContext } from 'next';
import { useTranslation } from 'utils/i18n';
import { serverSideTranslations } from '../../lib/serverSideTranslations';

const RegistrationPage = () => {
  const { t } = useTranslation('common');

  return (
    <Page
      title={t('headers.registration_page.title')}
      description={t('headers.registration_page.description')}
    >
      <div
        className="register-banner"
        style={{ backgroundImage: `url('../images/registration-banner.jpg')` }}
      />
      <main className="registration_page">
        <section>
          <div className="section-content">
            <Registration />
          </div>
        </section>
      </main>
    </Page>
  );
};

export const getServerSideProps = async ({
  locale,
}: GetServerSidePropsContext) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common'])),
    },
  };
};

export default RegistrationPage;
